import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '@app/core/services/alert.service';
import { ApiService } from '@app/core/services/api.service';
import { ICLEARSafety_AppUpdates } from '@app/shared/interfaces/ISystemSetting';
import { ClrLoadingState } from '@clr/angular';
import { take } from 'rxjs/internal/operators/take';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {
  launchBtn: ClrLoadingState = ClrLoadingState.DEFAULT;

  public RecentUpdates: ICLEARSafety_AppUpdates[] = null;
  public systemAvailable; // for health check
  constructor(
    private router: Router,
    private api: ApiService,
    private alert: AlertService
  ) {}

  ngOnInit() {
    this.healthCheck();
    if (sessionStorage.getItem('EnteredCredentials')) {
      this.router.navigateByUrl('/home');
    }
    this.getRecentUpdates();
  }

  public onLaunchClear() {
    this.launchBtn = ClrLoadingState.LOADING;
    this.router.navigateByUrl('/home');
  }

  public healthCheck() {
    this.api
      .healthCheck()
      .pipe(take(1))
      .subscribe(
        (res: string) => (this.systemAvailable = res),
        () => (this.systemAvailable = 'Unhealthy')
      );
  }

  loadRecentUpdates: boolean = false;
  public getRecentUpdates() {
    this.loadRecentUpdates = true;
    this.api.GetRecentUpdates().subscribe(
      (res: ICLEARSafety_AppUpdates[]) => {
        this.RecentUpdates = res;
        this.loadRecentUpdates = false;
      },
      () => {
        //Error Loading Recent updates
        this.alert.alert({
          message: 'Error Loading Recent updates',
          type: 'danger',
          duration: 5000,
        });
        this.loadRecentUpdates = false;
      },
      () => {
        this.loadRecentUpdates = false;
      }
    );
  }
}
